import React from 'react';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '../../helpers/formatterHelper'
import PropTypes from 'prop-types';
import NewsImages from './NewsImages';

const News = ({ newsItem }) => {
    const navigate = useNavigate();

    return (newsItem && (
        <a onClick={() => navigate('/news-details/' + newsItem.baseId)} className={`news-listing-item yellow`} key={newsItem}>
            <span className="news-title-wrap">
                {newsItem?.pinnedDateTime &&
                    <span className='news-title-pin-icon'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <mask id="mask0_15145_275" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
                            <rect width="18" height="18" transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 25.4561 12.728)" fill="white"/>
                            </mask>
                            <g mask="url(#mask0_15145_275)">
                            <path d="M14.5837 7.15959L10.7593 10.9841L9.09893 10.9842C9.02009 10.9842 8.94611 10.999 8.87699 11.0285C8.80805 11.058 8.74728 11.0991 8.69469 11.1517L8.46797 11.3784C8.35625 11.4901 8.30008 11.6235 8.29946 11.7786C8.29875 11.9337 8.3555 12.0683 8.46969 12.1825L10.4737 14.1865L7.616 17.0441C7.5033 17.1568 7.447 17.2894 7.44709 17.4419C7.44717 17.5944 7.50357 17.7269 7.61626 17.8396C7.72905 17.9524 7.86158 18.0088 8.01388 18.0087C8.16626 18.0087 8.2988 17.9523 8.41149 17.8396L11.2692 14.982L13.2732 16.9859C13.3874 17.1001 13.522 17.1569 13.677 17.1562C13.8321 17.1556 13.9656 17.0994 14.0773 16.9877L14.304 16.761C14.3566 16.7084 14.3976 16.6476 14.4272 16.5787C14.4567 16.5095 14.4714 16.4356 14.4714 16.3567L14.4716 14.6964L18.296 10.8719L18.4286 11.0045C18.5413 11.1172 18.6739 11.1735 18.8264 11.1734C18.9789 11.1734 19.1116 11.117 19.2243 11.0044C19.337 10.8916 19.3933 10.759 19.3932 10.6066C19.3932 10.4542 19.3368 10.3217 19.2241 10.209L15.2467 6.23151C15.134 6.11882 15.0014 6.06252 14.8489 6.0626C14.6963 6.0626 14.5637 6.11895 14.451 6.23165C14.3382 6.34443 14.2819 6.47701 14.2821 6.62939C14.2821 6.78178 14.3385 6.91431 14.4512 7.02701L14.5837 7.15959Z" fill="white"/>
                            </g>
                        </svg>
                    </span>
                }
                <span className="news-title-inner">                   

                    <div className="flex-wrap">
                    {newsItem.newsCompanies && newsItem.newsCompanies.length > 0 && (
                        <>
                            {newsItem.newsCompanies.map(item =>
                                <span key={item.companyId} className="news-day-title">
                                    {item.company.abbreviatedName}
                                </span>
                            )}
                        </>
                        )}
                    </div>

                    <span className="news-day-date">{formatDate(newsItem.publishDate, "MMM dd, yyyy")}</span>
                    

                    <span className="news-description">{newsItem.title}</span>
                </span>
                <span className="news-img-wrap">
                    <span className="news-image-wrap">
                       
                        {newsItem && newsItem.media && newsItem.media.length > 0 && (() => {
                            const media = newsItem.media.filter(x => !x.mediaItem?.videoThumbnailUrl?.includes("/static/media/"));
                            if (media.length > 0) {
                                return (
                                    <div className="video-event-wrap" key={media[0]?.id}>
                                        <NewsImages mediaItem={media[0]?.mediaItem} />
                                    </div>
                                );
                            }
                        })()}

                    </span>
                </span>
            </span>
        </a>
    )
    );
};
News.propTypes = {
    newsItem: PropTypes.object,
    isHrBenefits: PropTypes.bool
};

export default News;

